import { useTranslation } from 'react-i18next';
import { useInfluencerPermissions, useUserRoles } from '@anytag/auth';
import { ButtonLink } from '@anytag/shared-atoms';
import { cn } from '@anytag/shared-utils';

interface ButtonAddInfluencerProps {
  className?: string;
}

export const ButtonAddInfluencer = ({ className }: ButtonAddInfluencerProps) => {
  const { t } = useTranslation();
  const { hideAddInfluencerBtn } = useInfluencerPermissions();
  const { isAdminStaffTalentAgencyPartner } = useUserRoles();

  const hasAddInfluencerBtn = isAdminStaffTalentAgencyPartner && !hideAddInfluencerBtn;

  return hasAddInfluencerBtn ? (
    <ButtonLink
      variant="solid"
      to="/influencer/add"
      title={t('Button.Add Influencer')}
      prefixIcon={{ icon: 'plus', size: '10px' }}
      size="sm"
      className={cn('ml-auto min-w-34 capitalize', className)}
    />
  ) : null;
};
